import { render, staticRenderFns } from "./AiSettingsComponent.vue?vue&type=template&id=7c4485bb"
import script from "./AiSettingsComponent.vue?vue&type=script&lang=js"
export * from "./AiSettingsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports